<template>
  <div class="d-flex justify-start align-center my-6">
    <div class="iconDownload mr-3"></div>
    <div>
      附件下載：
      <a
        tabindex="0"
        :href="item.src"
        :download="item.name"
        :title="item.name"
        class="text-primary"
        style="cursor:pointer"
        >{{ item.name }}</a
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default() {
        return {
          src: "",
          name: ""
        };
      }
    }
  }
};
</script>
